<template>
  <td>
    <span
      class="lamp"
      :class="value ? 'blue' : 'red'"
      @click="$emit('click')"
    >{{value ? '알림성공' : '알림실패'}}</span>
  </td>
</template>

<script>
export default {
  props: {
    value: Boolean
  }
};
</script>

<style>
</style>